module.exports = __webpack_public_path__ + "static/img/dw3.5c1fe12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dw3.jpg
// module id = f7mL
// module chunks = 1